module.exports = __webpack_public_path__ + "catalog/items/monitor-pc/monitorPC.png";